import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Building2, ChevronDown, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { invalidateCatalog } from "../lib/catalog";

// Propietario multiempresa: cambiar la sucursal que se administra desde la misma cuenta
export default function BranchSwitcher() {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const [open, setOpen] = useState(false);
  const isOwner = !!user && (user.home_business_id || (user.license?.multi_company && user.license?.group_role === "principal" && user.role === "admin"));
  useEffect(() => {
    if (!isOwner) return;
    api.get("/group/companies").then(({ data }) => {
      const home = user.home_business_id || user.business_id;
      setBranches([{ business_id: home, business_name: user.home_business_id ? "Empresa principal" : user.license?.business_name, home: true }, ...data.companies.filter((c) => c.business_id !== home)]);
    }).catch(() => {});
  }, [isOwner, user?.business_id]); // eslint-disable-line
  const [askBranch, setAskBranch] = useState(false);
  useEffect(() => {
    if (isOwner && !user.home_business_id && branches.length > 1 && !sessionStorage.getItem("nx_branch_chosen")) setAskBranch(true);
  }, [isOwner, branches.length, user?.home_business_id]);
  if (!isOwner) return null;

  const go = async (bid) => {
    sessionStorage.setItem("nx_branch_chosen", "1");
    if (bid === user.business_id) { setAskBranch(false); setOpen(false); return; }
    try {
      const { data } = await api.post(`/group/switch/${bid}`);
      localStorage.setItem("nx_token", data.access_token);
      localStorage.removeItem("pos_station_id");
      invalidateCatalog();
      toast.success(data.is_home ? "De regreso en la empresa principal" : `Administrando: ${data.business_name}`);
      setTimeout(() => { window.location.href = "/dashboard"; }, 300);
    } catch (e) { toast.error(e.response?.data?.detail || "No se pudo cambiar de sucursal"); }
  };
  const current = user.acting_branch_name || user.license?.business_name || "";
  return (
    <div className="relative">
      {askBranch && (
        <div className="fixed inset-0 z-[90] bg-black/60 grid place-items-center p-4" data-testid="branch-picker">
          <div className="bg-white rounded-2xl p-5 w-full max-w-sm space-y-3 text-slate-900">
            <h3 className="font-display font-bold text-lg">¿A qué sucursal deseas ingresar?</h3>
            {branches.map((b) => <button key={b.business_id} type="button" onClick={() => go(b.business_id)} className="w-full text-left px-4 py-3 rounded-xl border border-border hover:border-emerald-500 hover:bg-emerald-50 font-semibold" data-testid={`branch-pick-${b.business_id}`}>{b.business_name}{b.home && <span className="ml-2 text-[10px] px-1.5 rounded bg-violet-100 text-violet-700">PRINCIPAL</span>}</button>)}
          </div>
        </div>
      )}
      <button type="button" onClick={() => setOpen((v) => !v)} className={`flex items-center gap-1.5 h-8 px-2.5 rounded-full text-xs font-bold border ${user.home_business_id ? "bg-violet-600 text-white border-violet-600" : "bg-violet-50 text-violet-700 border-violet-200"}`} data-testid="branch-switcher">
        <Building2 size={14} /> <span className="max-w-[160px] truncate">{user.home_business_id ? `Sucursal: ${current}` : "Mis sucursales"}</span> <ChevronDown size={14} />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-64 bg-white border border-border rounded-xl shadow-xl z-50 py-1" data-testid="branch-menu" onMouseLeave={() => setOpen(false)}>
          <div className="px-3 py-1.5 text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">Administrar sucursal</div>
          {branches.map((b) => (
            <button key={b.business_id} type="button" onClick={() => go(b.business_id)} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex items-center gap-2 ${b.business_id === user.business_id ? "font-bold text-violet-700" : ""}`} data-testid={`branch-go-${b.business_id}`}>
              {b.home ? <Undo2 size={14} /> : <Building2 size={14} />} {b.business_name}{b.business_id === user.business_id && <span className="ml-auto text-[10px] text-muted-foreground">actual</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
